module.exports = __webpack_public_path__ + "static/scalable-f7703bdd13c3833dd2840aafb2191841.jpg";